export default __webpack_public_path__ + "static/media/Hands-Checkmark.dc2d18df.svg";